<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SelectContainerInfo')"
    width="1055px"
    :close-on-click-modal="false"
    class="app-main-inner special-goods-container-usage-dialog"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button type="primary" @click="saveHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { queryByUnSpecialGoods } from '@/api/seaExport/containerUsage'
import * as EQSize from '@/class/cargo/model/parameters/EQSize'

export default {
  name: 'SpecialGoodsContainerUsageDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.ContainerSeqNo'),
          field: 'containerSeqNo',
          width: 80
        },
        {
          headerName: this.$t('SeaExport.ContainerId'),
          field: 'containerId',
          width: 80
        },
        {
          headerName: this.$t('SeaExport.ContainerSize'),
          field: 'eqSize',
          width: 70,
          cellRenderer: (params) => {
            return this.eqSizeItemLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerType'),
          field: 'uuid',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.containerUsageFiledLabelFunction(params.data, 'eqType')
          }
        },
        {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'containerNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeight',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNo',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          width: 70,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'),
          field: 'weight',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      gridApi: null,
      selectedData: {}
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.queryHandler()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.queryHandler()
    }
  },
  methods: {
    queryHandler() {
      queryByUnSpecialGoods({ jobUuid: this.jobUuid }).then(res => {
        this.rowData = res.data
      })
    },
    saveHandler() {
      const selUsages = this.gridApi.getSelectedRows()
      if (!selUsages || selUsages.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      const keysList = []
      for (const usage of selUsages) {
        keysList.push(usage.uuid)
      }
      this.$emit('linkUsagesEventHandler', keysList)
      this.innerVisible = false
    },
    eqSizeItemLabelFunc(value) {
      const eqSize = EQSize.getEQSizeByCode(value)
      return eqSize === null ? '' : eqSize.name
    }
  }
}
</script>

<style lang="scss">
.special-goods-container-usage-dialog {
  .el-dialog__body {
    padding: 5px !important;
    .el-form-item {
      margin-bottom: 0!important;
    }
  }
}
</style>
